import _ from 'lodash';
import urlJoin from 'url-join';
import settings from '../../config/settings';

export function isAnyRedirectEnabled(campaign) {
  return (campaign && (
      !campaign.isCookieRedirectDisabled ||
      !campaign.isFingerprintRedirectDisabled ||
      campaign.isDeviceRedirectActive ||
      campaign.isIspRedirectActive ||
      campaign.isGeoRedirectActive ||
      campaign.isQuotaRedirectActive ||
      !_.isEmpty(campaign.redirects))
  );
}

export function getPublisherIframeUrl(campaignId, rendererId) {
  return urlJoin(settings.frontendBaseURL, `publisher-iframe/${campaignId}/${rendererId}`);
}


const TRACKING_CODE_FB_EVENT_PLACEHOLDER = '{fb_event_id}';

export function getRendererTrackingCode(codeConfig, deviceType, eventType, eventId) {
  const {devices, event} = codeConfig;
  let code = '';
  if ((!eventType || event === eventType) && (_.isEmpty(devices) || devices.includes(deviceType))) {
    code = codeConfig.code;
  }
  // FB pixel templates:
  if (code && code.includes(TRACKING_CODE_FB_EVENT_PLACEHOLDER)) {
    code = code.replace(TRACKING_CODE_FB_EVENT_PLACEHOLDER, eventId);
  }
  return code;
}

export function getFbPixelEventId(userId, publisherId, adTrackingId, campaignId, templateName, eventType) {
  let eventId = [
    userId,
    publisherId || 'unknown_publisher',
    adTrackingId,
    campaignId,
    templateName,
    eventType
  ].join('-');
  eventId = eventId.replace(/[^a-zA-Z0-9\-_]/g, '');
  return eventId;
}
